import { render, staticRenderFns } from "./customer-quote-quicklink.vue?vue&type=template&id=1b98b1f2"
import script from "./customer-quote-quicklink.vue?vue&type=script&lang=js"
export * from "./customer-quote-quicklink.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports